import { Typography } from '@capsule/consumer-design-system';

import classNames from 'classnames';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import InlineSVG from 'svg-inline-react';

import bagSvg from 'public/Bag_New.svg';
import heartSvg from 'public/Heart_New.svg';
import pillBottle from 'public/PillBottle_New.svg';
import MarketingPageSection from 'src/app/components/Elements/MarketingPageSection';

import styles from './styles.module.scss';

const defaultSections = [
  {
    svg: <InlineSVG className={classNames(styles.pillBottle)} src={pillBottle} />,
    label: 'right now',
    title: 'You prescribe',
    content: (
      <>
        You e-prescribe to: <strong>Capsule.</strong>
        <br />
        Need help? Call or text us, or view our FAQs.
      </>
    ),
  },
  {
    svg: <InlineSVG className={classNames(styles.bag)} src={bagSvg} />,
    label: 'same day',
    title: 'We deliver',
    content: <>We immediately contact your patient to schedule free delivery within 2 hours.</>,
  },
  {
    svg: <InlineSVG className={classNames(styles.heart)} src={heartSvg} />,
    label: 'Forever & always',
    title: 'Rest assured',
    content: <>We follow up to deliver smart refills and send appointment reminders.</>,
  },
];

interface HowItWorksType {
  label?: string;
  title?: string;
  buttonCTA?: boolean;
  subtitle?: string;
  sectionData: typeof defaultSections;
  props?: any;
}

const HowItWorksSection = ({
  label = 'How it works',
  title = 'Capsule is effortless',
  buttonCTA = false,
  subtitle,
  sectionData = defaultSections,
  ...props
}: HowItWorksType) => {
  return (
    <MarketingPageSection {...props}>
      <Row>
        <Col xs="12" className="pb-5">
          <p className="font-label-callout uppercase font-down-2">{label}</p>
          <Typography variant="displayXl">{title}</Typography>
          {subtitle && <h3 className="font-sub-header font-h-2">{subtitle}</h3>}
        </Col>
      </Row>
      <Row>
        {map(sectionData, (section, i) => {
          let sectionBorder = null;

          if (i < sectionData.length - 1) {
            sectionBorder = styles.section;
          }
          return (
            <Col
              xs="12"
              sm="4"
              className={classNames(sectionBorder, 'pr-0', 'pr-sm-5', 'py-3')}
              key={label + title + i}
            >
              <Row className={classNames(styles.sectionInner)}>
                <Col xs="4" sm="12" className={styles.sectionIconContainer}>
                  {section.svg}
                </Col>
                <Col xs="8" sm="12">
                  <p className={classNames('pt-5 font-label-overline font-down-2', styles.labelText)}>
                    {section.label}
                  </p>
                  <h3 className="font-h-2 pt-0">{section.title}</h3>
                </Col>
                <Col xs="12">
                  <p>{section.content}</p>
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
      {buttonCTA && (
        <div className={classNames(styles.buttonContainer, 'py-4')}>
          <Link className="link-btn link-btn__primary link-btn__medium" to={'/'}>
            Let&#8217;s do this
          </Link>
        </div>
      )}
    </MarketingPageSection>
  );
};

HowItWorksSection.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonCTA: PropTypes.bool,
  sectionData: PropTypes.array,
};

export default HowItWorksSection;
